<template>
  <div class="container">

    <h1>
      <font-awesome-icon icon="home" /> Home - <a href="#">Wallet</a>

      <div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>
 

        <b-modal id="modal-lg" size="lg" title="Wallet">


          <div class="panal">
            <div>

              <div class="panal-header"> {{ info.PageName ? info.PageName : '' }}</div>
              <div class="panal-body">

                <div v-html="info.PageDescription"></div>
              </div>
            </div>



          </div>

          <div class="panal" v-for="help in info.HelpSection" :key="help.serial">
            <div>

              <div class="panal-header"> {{ help.SectionName }}</div>
              <div class="panal-body">

                <div v-html="help.SectionDescription"></div>
              </div>
            </div>



          </div>







        </b-modal>

      </div>



    </h1>




    <div class="row">

      <div class="col-md-12 mt-3 mb-3">



        <div class="accordion" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button class="btn btn-link text-left" type="button" data-toggle="collapse" data-target="#collapseOne"
                  aria-expanded="true" aria-controls="collapseOne">
                  Paid

                </button>
              </h2>
            </div>

            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="card-body">
                <div class="text-center" v-if="loading">
                  <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>
                <div class="row" v-if="PaidApplicantPaymentsList.length != 0 && !loading">
                  <div class="col-sm-4" v-for="Item in PaidApplicantPaymentsList" v-bind:Key="Item.serial">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">{{Item.SemesterName}}</h5>
                        <p class="card-text">Value <span class="float-right">{{Item.Value}}</span></p>
                        <p class="card-text">From <span
                            class="float-right">{{Item.PaymentDateFrom | moment("ll")}}</span></p>
                        <p class="card-text">To <span class="float-right">{{Item.PaymentDateTo | moment("ll")}}</span>
                        </p>
                        <p class="card-text">Payment Date <span
                            class="float-right">{{Item.PaymentDate | moment("ll")}}</span></p>
                        <p class="card-text">Receipt No <span class="float-right">{{Item.ReceiptNumber}}</span></p>
                        <p class="card-text">Payment Name <span class="float-right name">{{Item.PaymentTypeNameEN}}</span>
                        </p>
                        <p class="card-text">Employee Name <span class="float-right">{{Item.EmployeeNameEN}}</span></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-else-if="!loading">
                  <div class="col-sm-4">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Payment Information</h5>
                        No Paymnet Available

                      </div>
                    </div>

                  </div>

                </div>



              </div>
            </div>
          </div>
          <div class="card" v-if="UnPaidApplicantPaymentsList.length != 0 ">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                  data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Un Paid
                </button>
              </h2>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div class="card-body">
                <div class="text-center" v-if="loading">
                  <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>
                <div class="row" v-if="UnPaidApplicantPaymentsList.length != 0 && !loading">

                  <div class="col-sm-4" v-for="Item in UnPaidApplicantPaymentsList" v-bind:Key="Item.serial">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">{{Item.SemesterName}}</h5>
                        <p class="card-text">Value <span class="float-right">{{Item.Value}}</span></p>
                        <p class="card-text">From <span
                            class="float-right">{{Item.PaymentDateFrom | moment("ll")}}</span></p>
                        <p class="card-text">To <span class="float-right">{{Item.PaymentDateTo | moment("ll")}}</span>
                        </p>
                        <p class="card-text">Payment Date <span class="float-right"
                            :class="Item.PaymentDate ? '' : 'text-danger'">{{Item.PaymentDate ? Item.PaymentDate : 'Pending Payment'}}</span>
                        </p>
                        <p class="card-text">Receipt No <span class="float-right">{{Item.ReceiptNumber}}</span></p>
                        <p class="card-text">Payment Name <span class="float-right desc">{{Item.Description}}</span>
                        </p>
                        <p class="card-text">Employee Name <span class="float-right">{{Item.EmployeeNameEN}}</span></p>

                      </div>
                      <div class="card-footer" v-if="Item.FawryAvailability == 'Available'">
                        <label :for=Item.serial><input type="checkbox" :name=Item.serial id="select" :value=Item.serial
                            v-model="SelectedList"> Select For Payment </label>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="row" v-else-if="!loading">
                  <div class="col-sm-4">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Payment Information</h5>
                        No Payment Available

                      </div>
                    </div>

                  </div>

                </div>



              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingThree">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                  data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Payment methods
                </button>
              </h2>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
              <div class="card-body">

                <div class="row">
                  <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title"> Fawry Pay</h5>
                        <p class="card-text"> All your selected payments will be sent to Fawry for payment </p>
                        <input type="image" @click="FawryPayment"
                          src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png"
                          alt="Edfa3 Fawry" id="xsrrs" />


                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Bank Misr</h5>
                        <p class="card-text">Account Number <span class="float-right">4330240000014373</span></p>
                        <button type="button" class="btn btn-primary mr-1" @click="$router.push('paymentorder')">Payment
                          Order</button>


                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Bank Masr</h5>
                        <p class="card-text">All your selected payment to bank masr </p>
                         <input type="image" @click="BMPayment" width="150" height="50"
                          src="https://inlegal.eu/wp-content/uploads/2019/05/visa-and-mastercard-logo-26.png"
                          alt="visa payment"  />


                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Meeza Payment</h5>
                        <p class="card-text">All your selected payment to Meeza </p>
                         <input type="image" @click="MizaPayment" width="150" height="50"
                          src="https://upload.wikimedia.org/wikipedia/en/3/37/Meeza_Egyptian_company_logo.png"
                          alt="visa payment"  />
                          


                      </div>
                    </div>
                  </div> -->
                </div>



              </div>
            </div>
          </div>
        </div>

      </div>


    </div>




  </div>

</template>

<script>
  import axios from 'axios'
  import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'
  import {
    ApplicantPaymentList
  } from '../../models/Applicant'
  import {
    API_URL
  } from '../../services/API_URL'


  export default {
    components: {

    },
    data() {
      return {
        info: '',
        AllPayment: [],
        PaidApplicantPaymentsList: new ApplicantPaymentList('', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
          '', '', ''),
        UnPaidApplicantPaymentsList: new ApplicantPaymentList('', '', '', '', '', '', '', '', '', '', '', '', '', '',
          '', '', '', ''),
        submitted: false,
        loading: false,
        successful: false,
        message: '',
        SelectedList: [],
        SentPayemtList: [],
      }
    },
    methods: {



      FawryPayment() {

        this.$store.dispatch('auth/payment', this.selectpayment).then(
          () => {
            localStorage.setItem('payment', JSON.stringify(this.selectpayment));
            this.$router.push('/fawry')
          })

      },
      BMPayment(){
        this.$store.dispatch('auth/payment', this.selectpayment).then(
          () => {
            localStorage.setItem('payment', JSON.stringify(this.selectpayment));
            this.$router.push('/bmpayment')
          })
      },
      MizaPayment(){
        this.$store.dispatch('auth/payment', this.selectpayment).then(
          () => {
            localStorage.setItem('payment', JSON.stringify(this.selectpayment));
            this.$router.push('/Mizapayment')
          })
      }
    },
    computed: {
      currenUser() {
        return this.$store.state.auth.user
      },
      selectpayment() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.SentPayemtList = this.UnPaidApplicantPaymentsList.filter(x => {
          if (this.SelectedList.includes(x.PaymentID)) {
            return x
          }
        })

      },
      PaymentStore() {
        return this.$store.state.auth.paymentList
      }
    },
    mounted() {
      this.loading = true
      let id = 7;

      axios.get(API_URL + `/HelpPages/SelectHelpPageAndSection?PageId=${id}`)
        .then(response => {
          this.info = response.data
          //console.log(response.data);
        }),
        // eslint-disable-next-line no-unused-vars
        ApplicantDataServices.ApplicantUpdatePaymnet(this.currenUser.UserIDSerial).then(res =>

          this.$store.dispatch('auth/Review', this.reviewApplication + 1)

        ).finally(() => {

          ApplicantDataServices.GetListofApplicantPayments(this.currenUser.UserIDSerial).then(Response => {
            this.AllPayment = Response.data
            this.PaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues == "Paid")
            this.UnPaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues != "Paid")
            this.loading=false
          }, error => {
             this.loading=false
            this.PaidApplicantPaymentsList = [];
            this.UnPaidApplicantPaymentsList = [];
            this.message =
              (error.response && error.response.data && error.response.data.Message) ||
              error.message ||
              error.toString();
          }).catch(error => {
             this.loading=false
            this.PaidApplicantPaymentsList = []
            this.UnPaidApplicantPaymentsList = []
            this.message = error + 'no data '
          })


        }),
         // eslint-disable-next-line no-unused-vars
        ApplicantDataServices.ApplicantBankMasr_MPGSWalletRetrieveOrder(this.currenUser.UserIDSerial).then(res =>

          this.$store.dispatch('auth/Review', this.reviewApplication + 1)

        ).finally(() => {

          ApplicantDataServices.GetListofApplicantPayments(this.currenUser.UserIDSerial).then(Response => {
            this.AllPayment = Response.data
            this.PaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues == "Paid")
            this.UnPaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues != "Paid")
            this.loading=false
          }, error => {
             this.loading=false
            this.PaidApplicantPaymentsList = [];
            this.UnPaidApplicantPaymentsList = [];
            this.message =
              (error.response && error.response.data && error.response.data.Message) ||
              error.message ||
              error.toString();
          }).catch(error => {
             this.loading=false
            this.PaidApplicantPaymentsList = []
            this.UnPaidApplicantPaymentsList = []
            this.message = error + 'no data '
          })


        })
         // eslint-disable-next-line no-unused-vars
        ApplicantDataServices.ApplicantBankMasr_UPGSWalletRetrieveOrder(this.currenUser.UserIDSerial).then(res =>

          this.$store.dispatch('auth/Review', this.reviewApplication + 1)

        ).finally(() => {

          ApplicantDataServices.GetListofApplicantPayments(this.currenUser.UserIDSerial).then(Response => {
            this.AllPayment = Response.data
            this.PaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues == "Paid")
            this.UnPaidApplicantPaymentsList = this.AllPayment.filter(x => x.PaymentStatues != "Paid")
            this.loading=false
          }, error => {
             this.loading=false
            this.PaidApplicantPaymentsList = [];
            this.UnPaidApplicantPaymentsList = [];
            this.message =
              (error.response && error.response.data && error.response.data.Message) ||
              error.message ||
              error.toString();
          }).catch(error => {
             this.loading=false
            this.PaidApplicantPaymentsList = []
            this.UnPaidApplicantPaymentsList = []
            this.message = error + 'no data '
          })


        })
    },

  }
</script>

<style scoped>
  @import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css');

  .help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}

  h1 {
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
  }

  h1 a {
    color: #ff8600;
  }

  .card-header {
    padding: .35rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, .03);
    border-bottom: 1px solid rgba(0, 0, 0, .125);
    border-left: 3px solid #EDBD88;
  }

  .card-header:active {

    border-left: 3px solid #91DC5A;
    width: 100%;
    height: 100%;
    margin: 0px;
  }

  .card-header h2 [data-toggle="collapse"]:before {
    font-family: FontAwesome;
    content: "\f058";
    display: inline-block;
    padding-right: 11px;
    vertical-align: middle;
    font-weight: 900;
    color: #91DC5A;
    aria-expanded: true
  }

  .card-header h2 [data-toggle="collapse"].collapsed:before {
    font-family: FontAwesome;
    content: "\f058";
    display: inline-block;
    padding-right: 11px;
    vertical-align: middle;
    font-weight: 900;
    color: #E6E6E6;

  }

  .card {
    margin-bottom: 20px;
  }

  .btn-link {
    font-weight: 700;
    color: #285475;
    text-decoration: none;
    font-size: 20px;
    text-decoration: none;

  }

  .btn-link a {
    text-decoration: none;
  }

  .card-text {
    border-bottom: 1px #333 dotted;
    padding: 0px 0px;
  }

  .card-text:last-child {
    border-bottom: none;
    padding: 0px 0px;
  }

  .card-text span {
    color: #ff8600;
    text-size-adjust: auto;
  }

  p {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  .panal {
    background: #eee;
    border-radius: 10px;
    color: #333;
    border: 1px solid #d4d4d4;
    padding: 0px 0px 20px 0px;
    margin: 10px 0;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


  }

  .panal-header {
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
    width: 50%;
    /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
  }

  .panal-body {
    padding: 20px;
    color: #333;
  }

  @media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>